import axios from 'axios'
import { processRound } from '@/store/modules/rounds/index'

// state
export const state = {
  isRoundLoading: false,
  round: null,
}

// getters
export const getters = {
}
// mutations
export const mutations = {
  fetchRoundStarted(state) {
    state.isRoundLoading = true
  },
  fetchRoundSuccess(state, { round }) {
    const today = new Date()
    state.round = processRound(round, today)
    state.isRoundLoading = false
  },
  fetchRoundFailed(state) {
    state.isRoundLoading = false
  },
}
// actions
export const actions = {
  async fetchRoundHistory({ commit }, { roundId }) {
    try {
      commit('fetchRoundStarted')
      const round = await axios.get(`round/${roundId}`)
      commit('fetchRoundSuccess', { round })
      return round
    } catch (e) {
      console.error(e)
      commit('fetchRoundFailed')
    }
  },
}
